import { FormControl, FormGroup, Validators } from "@angular/forms";

export class MediaCategoryNames {
  mediaCategoryNameId: number;
  alternateName: string;
  mediaCategoryId: number;
  comments: string;
  isActive: boolean;

  static asFormGroup(category: MediaCategoryNames): FormGroup {
    const fg = new FormGroup({
      mediaCategoryNameId: new FormControl(category.mediaCategoryNameId),
      alternateName: new FormControl(category.alternateName, Validators.required),
      mediaCategoryId: new FormControl(category.mediaCategoryId),
      comments: new FormControl(category.comments),
      isActive: new FormControl(category.isActive)
    });
    return fg;
  }
}
